import { Box, Card, Typography, Divider, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ActionType, InsuranceType } from '../constants';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';

const BenefitCard = ({ item, selectedCompanyEntity }) => {
    const navigate = useNavigate();
    const userData = useSelector(state => state.user?.userData);

    const handleInsuranceCardClick = (action, insuranceType) => {
        trackAnalyticsEvent('BENEFICIARY_INSURANCE_CARD_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_type: insuranceType || item?.value || '',
            benefit_status: item?.status?.label || '',
            benefit_amount: item?.amount || ''
        });
    };

    const handleAddBeneficiaryClick = () => {
        trackAnalyticsEvent('BENEFICIARY_ADD_BENEFICIARY_BUTTON_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_type: item?.value || ''
        });
        navigate('/beneficiary/add-beneficiary', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    const handleViewDetailsClick = () => {
        handleInsuranceCardClick('VIEW', item?.value);
        navigate('/beneficiary/detail', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    const handleAddNomineeClick = () => {
        trackAnalyticsEvent('BENEFICIARY_ADD_NOMINEE_BUTTON_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_type: item?.value || '',
            beneficiary_id: item?.beneficiary_id || ''
        });
        handleInsuranceCardClick('ADD_NOMINEE', item?.value);
        navigate('/beneficiary/add-nominee', { state: { insurance_type: item?.value, beneficiary_id: item?.beneficiary_id, selectedCompanyEntity: selectedCompanyEntity } });
    };

    const handleAddBankDetailsClick = () => {
        handleInsuranceCardClick('ADD_BANK_DETAILS', item?.value);
        navigate('/beneficiary/add-bank-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };
    const handleAddShopDetails = () => {
        handleInsuranceCardClick('ADD_SHOP_DETAILS', item?.value);
        navigate('/beneficiary/add-shop-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };
    const handleViewShopDetails = () => {
        handleInsuranceCardClick('SHOP_DETAILS', item?.value);
        navigate('/beneficiary/shop-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    const handleStaffDetails = () => {
        handleInsuranceCardClick('STAFF_DETAILS', item?.value);
        navigate('/beneficiary/staff-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    
    return (
        <Card sx={{
            boxShadow: 'none',
            p: 2, borderRadius: 3,
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2  }}>
                    <Box>
                        <img src={item?.logo_url} style={{ height: 'auto', width: 45 }} alt={item?.name} />
                    </Box>
                    <Box sx={{ ml: 2 }}>
                        <Typography variant='h2'>{item?.name}</Typography>
                        <Typography variant='p3' sx={{ color: "#666"}}>{item?.description}</Typography>
                    </Box>
                </Box>
                <Box>
                    <Typography sx={{ fontSize: '16px', lineHeight: '24px', color: item?.status?.color, fontWeight: 'bold' }}>{item?.status?.label}</Typography> 
                </Box> 
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: 600, color: '#818181' }}>
                        Amount 
                    </Typography>
                    <Typography sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: 600, color: '#818181' }}>
                        {item?.amount || '-'}
                    </Typography>
                </Box>
                {item?.action_button?.show && item.beneficiary_id && item.nominee_id && (
                    <Button onClick={handleViewDetailsClick} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                    
                )}
                {item?.action_button?.show && item.beneficiary_id && !item.nominee_id  && item?.value === InsuranceType.MEDICAL_INSURANCE &&  (
                    <Button onClick={handleViewDetailsClick} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {item?.action_button?.show && !item.beneficiary_id && item?.value !== InsuranceType.GAP_BENEFIT && item?.value !== InsuranceType.STAFF_INSURANCE &&  item?.value !== InsuranceType.SHOP_INSURANCE && (
                    <Button onClick={handleAddBeneficiaryClick} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {item?.action_button?.show && item.beneficiary_id && !item.nominee_id && item?.value !== InsuranceType.MEDICAL_INSURANCE &&  (
                    <Button onClick={handleAddNomineeClick} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {item?.action_button?.show && item?.value === InsuranceType.GAP_BENEFIT && item?.action_button?.label === ActionType.VIEW && (
                    <Button onClick={handleViewDetailsClick} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {item?.action_button?.show && item?.value === InsuranceType.GAP_BENEFIT && item?.action_button?.label === ActionType.ADD &&  (
                    <Button onClick={handleAddBankDetailsClick} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {(item?.action_button?.show && item?.value === InsuranceType.SHOP_INSURANCE && item?.action_button?.label === ActionType.ADD) &&  (
                    <Button onClick={handleAddShopDetails} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {(item?.action_button?.show && item?.value === InsuranceType.SHOP_INSURANCE && item?.action_button?.label === ActionType.VIEW) &&  (
                    <Button onClick={handleViewShopDetails} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
                {(item?.action_button?.show && item?.value === InsuranceType.STAFF_INSURANCE ) &&  (
                    <Button onClick={handleStaffDetails} variant="outlined" color="primary" size="small" sx={{ textTransform: 'none' }}>
                        {item?.action_button?.label}
                    </Button>
                )}
            </Box>
        </Card>
    );

};

export default BenefitCard;
